<template>
  <div :class="showPopup? 'modalWrapper visible':'modalWrapper'">
    <div class="modal">
      <a href="#" class="bt_modalClose" @click.prevent="closeModal"><i class="fa fa-times"/></a>
      <img :src="flyerUrl" alt="Plop banner" @click.prevent="openLink">
    </div>
  </div>
</template>
<script setup lang="ts">
import {ref} from 'vue'
import api from "~/api";
const showPopup = ref(false)
const flyerUrl = ref('')
const flyerHref = ref(null)

function closeModal() {
  showPopup.value = false;
}

function openLink() {
  if (flyerHref.value !== null) {
    window.location = flyerHref.value;
  }
  return;
}

onMounted(async () => {
  const flyers = await api.HomeFlyers.listActiveHomeFlyers()

  if (flyers.data.length > 0) {
    const randomId = Math.floor(Math.random() * flyers.data.length);
    flyerUrl.value = flyers.data[randomId].realPath ?? ''
    const possibleFlyerLink = flyers.data[randomId].href ?? null
    if (possibleFlyerLink) {
      flyerHref.value = possibleFlyerLink;
    }

    showPopup.value = true
    setTimeout(
        () => {
          closeModal()
        },
        5000
    )
  }
})


</script>